













































































































import { getFollowLogDetailApi, getFollowStageApi } from "@/api/studentFollow";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component({
  name: "logFollowDialog",
  components: {},
})
export default class extends Vue {
  @Prop() logData!: any;
  @Prop() modeList!: any[];
  // @Prop() stageList!: any[];
  @Prop() lantentList!: any[];
  form: any = {};
  followLatent: any[] = [];
  followModeList: any[] = [];
  followStageList: any[] = [];
  dialogVisible: boolean = false;
  openDialog() {
    getFollowLogDetailApi({ follow_id: this.logData.id }).then((res: any) => {
      res.data.images_url = res.data.images_url || [];
      res.data.pre_follow_time = res.data.pre_follow_time * 1000;
      this.form = res.data;
      this.dialogVisible = true;
    });
    this.followLatent = this.lantentList;
    this.followModeList = this.modeList;
    // this.followStageList = this.stageList;
    // 跟进阶段会随学员类型改动，需要即时获取
    getFollowStageApi({}).then((res: any) => {
      this.followStageList = res.data.list;
    });
    this.dialogVisible = true;
  }
  closeDialog() {
    this.dialogVisible = false;
  }
  toOrderDetail(id: number) {
    this.$router.push({
      name: "orderManageDetail",
      query: {
        id: String(id),
      },
    });
  }
}
